export default {
    acceptPayPalTerms: {
        text: 'Accept that when you pay with PayPal and make / receive a refund, it will not be refunded via your bank, but instead will be refunded as points to your user account. These points reflect the amount paid in points, and can be used at a later date',
        title: 'PayPal payment',
        accept: 'Accepts',
        cancel: 'Cancel'
    }
}